import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  templates: [], // Initial templates array
};

const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    setTemplates: (state, action) => {
      state.templates = action.payload;
    },
    addTemplate: (state, action) => {
      state.templates.push(action.payload);
    },
    updateTemplate: (state, action) => {
      const updatedTemplate = action.payload;

      state.templates = state.templates.map((prevTemplate) =>
        prevTemplate.id === updatedTemplate.id ? updatedTemplate : prevTemplate
      );

    },
    deleteTemplate: (state, action) => {
      const templateIndex = state.templates.findIndex(
        (template) => template.id === action.payload
      );
      if (templateIndex !== -1) {
        state.templates.splice(templateIndex, 1);
      }
    },
  },
});

export const {
  setTemplates,
  addTemplate,
  updateTemplate,
  deleteTemplate,
} = templateSlice.actions;

export default templateSlice.reducer;